export default __webpack_public_path__ + "static/media/h-redes-sociais.e072e347.webp";